// EmailJS Configuration
// Sign up at https://www.emailjs.com/ to get your own credentials

const emailConfig = {
  userId: "EFfHCEK45xiyGLJd9", // Replace with your EmailJS user ID
  serviceId: "service_t6chhz8", // Replace with your EmailJS service ID
  templateId: "YOUR_TEMPLATE_ID", // Replace with your EmailJS template ID
  recipientEmail: "afrotechgroupza@gmail.com" // The email address that will receive the contact form submissions
};

export default emailConfig;
